import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldPhoneComponent } from './field-phone.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';



@NgModule({
  declarations: [
    FieldPhoneComponent
  ],
  exports: [
    FieldPhoneComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  ]
})
export class FieldPhoneModule { }
